document.querySelectorAll('.filter').forEach((wrap) => {
  // Open filter
  const buttonOpen = wrap.querySelector('.filter__button-open .button');
  const openFilter = () => {
    wrap.classList.add('filter--expanded');
  };
  buttonOpen.addEventListener('click', openFilter);
  // Close filter
  const buttonClose = wrap.querySelector('.filter__button-close .button');
  const closeFilter = () => {
    wrap.classList.remove('filter--expanded');
  };
  buttonClose.addEventListener('click', closeFilter);
});

document.querySelectorAll('.filter__filter__form').forEach((form) => {
  const filters = form.querySelectorAll('.select__select');
  const formSubmit = () => {
    form.submit();
  };
  filters.forEach(filter => filter.addEventListener('change', formSubmit));
});
